import {format} from 'date-fns'

/**
 * Formats a date conditionally, based on whether it is further than a year from now or not.
 * @param {Date} date
 * @param {string} olderFormat Format to use on a date further than a year ago/in the future
 * @param {string} recentFormat Format to use on a date less than a year ago/in the future
 * @returns {string} Formatted date string
 */
export const formatDateByAge = (
  date: Date,
  furtherFormat: string = 'MMM yyyy',
  recentFormat: string = 'MMM d'
) => {
  const now = new Date()

  const yearFromNow = new Date(now)
  yearFromNow.setFullYear(now.getFullYear() + 1)

  const yearAgo = new Date(now)
  yearAgo.setFullYear(now.getFullYear() - 1)

  if (date >= yearFromNow || date <= yearAgo) {
    return format(date, furtherFormat)
  } else {
    return format(date, recentFormat)
  }
}
